import http from 'utils/http'

const additionalInfo = emailList => http.post('/user/v1/customer/additional-info', emailList)

const createCustomerDeliveryAddress = payload =>
  http.post('/user/v1/customerDeliveryAddress', payload)

const getListCustomerDeliveryAddress = () =>
  http.get('/user/v1/customerDeliveryAddress')

const deleteCustomerDeliveryAddress = (id) =>
  http.post('/user/v1/customerDeliveryAddress', id)

export default {
  additionalInfo,
  createCustomerDeliveryAddress,
  getListCustomerDeliveryAddress,
  deleteCustomerDeliveryAddress
}



// WEBPACK FOOTER //
// ./src/services/customerService.js